import { Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import sensitiveContentMark from '../../../../images/Sensitive_No_Border_Shield.svg';
import { Action } from '../../../common/components/action';
import BasicModal from '../../../common/components/basic_modal';

export default function SensitiveContentConfirmModal({ onSubmit, onClose, pendingRequest }) {
  const [checkboxChecked, setCheckboxChecked] = useState(false);

  const handleCheckboxChange = ({ target }) => {
    setCheckboxChecked(target.checked);
  };

  return (
    <BasicModal.Container id="sensitive-content-confirm-modal" onClose={onClose}>
      <BasicModal.Header onClose={onClose}>
        <h4 className="text-red-600">Some items are tagged as sensitive content</h4>
      </BasicModal.Header>
      <BasicModal.Body>
        <div className="flex justify-between">
          <div>
            <FormControlLabel
              control={<Checkbox checked={checkboxChecked} onChange={handleCheckboxChange} />}
              label="I acknowledge this and would like to continue"
            />
          </div>
          <div className="resource-badge pull-right m-0">
            <img src={sensitiveContentMark} alt="Sensitive Content" />
          </div>
        </div>
      </BasicModal.Body>
      <BasicModal.Footer>
        <Action name="Cancel" styleClass="btn btn-default" callbackFunction={onClose} />
        <Action
          name="Accept"
          loading={pendingRequest}
          styleClass="btn btn-primary confirm remove-collection-item mr5"
          callbackFunction={onSubmit}
          disabled={!checkboxChecked}
        />
      </BasicModal.Footer>
    </BasicModal.Container>
  );
}

SensitiveContentConfirmModal.propTypes = {
  message: PropTypes.string,
  isDisabled: PropTypes.bool,
  pendingRequest: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func
};
